import {Navigate} from "react-router-dom"
import {Component} from "react"
import i18n from "i18next"
import styled from "styled-components"
import {Table} from "../common/table.component"
import {Column} from "react-table"
import {DefaultApi, PartnerGet} from "../../webservice"
import {getCurrentUser} from "../login.component";
import Header from "../common/header.component";
import {defaultError, defaultSuccess} from "../../utils/general";

type Props = {};

type State = {
    partners?: PartnerGet[];
    partner?: PartnerGet;
    message?: string;
    error?: boolean;
    isSubmitting?: boolean;
}

const api: DefaultApi = new DefaultApi();

const Styles = styled.div`
  table {
    border-spacing: 0;

    tr {
      :last-child {
        td {
          border-bottom: 0;
        }
      }
    }

    th,
    td {
      margin: 0;
      padding: 0.5rem;

      :last-child {
        border-right: 0;
      }
    }
  }
`

export default class PartnersView extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {}
        this.onRowClicked = this.onRowClicked.bind(this);
    }

    componentDidMount() {
        api.partnersGet({
            withCredentials: true
        }).then(
            response => {
                defaultSuccess(response, this, "")
                this.setState({
                    partners: response.data.sort((a, b) => a.prt_id - b.prt_id),
                });
            }
        ).catch(
            error => defaultError(error, this)
        );
    }

    onRowClicked(row: any) {
        this.setState({
            partner: row.values
        })
    }

    partnerTable() {
        const columns: Column<object>[] = [
            {
                Header: i18n.t("Name").toString(),
                columns: [
                    {
                        Header: i18n.t("ID").toString(),
                        accessor: "prt_id",
                    },
                    {
                        Header: i18n.t("Partner no.").toString(),
                        accessor: "prt_partner_nr",
                    },
                    {
                        Header: i18n.t("Name").toString(),
                        accessor: "prt_namn",
                    },
                    {
                        Header: i18n.t("Description").toString(),
                        accessor: "prt_benamn",
                    },
                ],
            },
            {
                Header: i18n.t("Info").toString(),
                columns: [
                    {
                        Header: i18n.t("Organization ID").toString(),
                        accessor: "prt_org_nr",
                    },
                    {
                        Header: i18n.t("Mobile").toString(),
                        accessor: "adm_mobil_nr",
                    },
                    {
                        Header: i18n.t("Status").toString(),
                        accessor: "prt_online",
                    },
                    {
                        Header: i18n.t("State").toString(),
                        accessor: "prt_test_prod_flag",
                    },
                ],
            },
        ];

        const tableOptions = {
            columns: columns,
            data: this.state.partners || []
        };

        return (
            <Styles>
                <Table tableOptions={tableOptions} callback={this.onRowClicked}/>
            </Styles>
        )
    }

    render() {
        if (!getCurrentUser())
            return <Navigate to={"/login?back=" + window.location.pathname}/>;
        if (this.state.partner)
            return <Navigate to={this.state.partner.prt_id.toString()}/>;
        return (
            <div className="component">
                <Header title={i18n.t("Partners")}/>
                <div className="content">
                    <a className={"btn btn-primary mb-3"} href={"/admin/partners/0"}>{i18n.t("Create new")}</a>
                    {this.state.partners && this.partnerTable()}
                </div>
            </div>
        )
    }
}
